import { ModalAction, ModalState } from '../model/documents.model';

export const documentsReducer = (state: ModalState, action: ModalAction) => {
  switch (action.type) {
    case 'OPEN_DELETE_MODAL':
      return { ...state, deleteModalOpen: true };
    case 'CLOSE_DELETE_MODAL':
      return { ...state, deleteModalOpen: false };
    case 'OPEN_RENAME_MODAL':
      return { ...state, renameModalOpen: true };
    case 'CLOSE_RENAME_MODAL':
      return { ...state, renameModalOpen: false };
    case 'OPEN_UPLOAD_MODAL':
      return { ...state, uploadModalOpen: true };
    case 'CLOSE_UPLOAD_MODAL':
      return { ...state, uploadModalOpen: false };
    default:
      return state;
  }
};
